import React, { Component } from "react";
import { Router } from "react-router-dom";
import "./App.css";
import Home from "pages/Home";

class App extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div>
          <Home/>
      </div>
    );
  }
}

export default App;
